module.exports = __webpack_public_path__ + "static/media/bag-check-white.e76b3e7e.svg";